import Awards from "@pages/awards/awards";
import MyGiftRequests from "@pages/awards/my-requests";
import React from "react";

const ChangePoints = React.lazy(() =>
  import("@pages/awards/index")
);
const PhoneRecharge = React.lazy(() =>
  import("@pages/awards/phone-recharge/index")
);
const Coupons = React.lazy(() =>
  import("@pages/awards/coupons/index")
);

export const awards_routes = [
  // when logged in and user wants to change his password
  {
    index: true,
    element: <Awards />
  },
  { path: "/awards/change-points", element: <ChangePoints /> },
  { path: "/awards/phone-recharge", element: <PhoneRecharge /> },
  { path: "/awards/coupons", element: <Coupons /> },


    {
      path: "/awards/my-requests",
      element: <MyGiftRequests />
    }

];
